<template>
  <div class="btnPrecioClass" v-if="showBtn">
    <div class="precio-div" v-if="isProductDetail">
      <p class="precio-p">
        <strong class="precio-strong">Precio:</strong><br />
        {{ precio }}
      </p>
    </div>

    <div v-if="!isProductDetail">
      <p>
        {{ precio }}
      </p>
    </div>
  </div>
</template>

<script>
import login from "./../views/user-views/login.vue";
import register from "./../views/user-views/register.vue";

export default {
  name: "btnPrecio",

  components: {
    login,
    register,
  },

  data() {
    return {
      showBtn: false,
      session: false,
      precio: "",
      showPrecio: false,
      dialog: false,
      isClient: false,
    };
  },

  props: {
    itemId: { type: String },
    unitType: { type: String },
    sendSnack: { type: Function },
    clientId: { type: String },
    isProductDetail: { type: Boolean },
  },

  methods: {
    getPrecio: async function (itemId, unitType, clientId) {
      let price;
      let res = await this.$http({
        method: "get",
        url: `https://market.risoul.com.mx/api/product/precioMoneda/${itemId}/${clientId}`,
      });

      if (res.status == 200) {
        price = res.body;
        if (price.precio != "Precio no disponible") {
          let precio = Math.round(price.precio * 100) / 100;
          let moneda =
            price.moneda == "pesos" || price.moneda == "Pesos"
              ? "MXN"
              : price.moneda;
          this.precio =
            res.body.precio == 0
              ? "Agregarlo a lista para su cotización"
              : `$ ${precio} ${moneda}`;
          this.precio =
            this.isProductDetail && res.body.precio == 0
              ? this.precio
              : unitType == "PIEZA"
              ? `${this.precio}  c/u`
              : unitType == "METROS"
              ? `${this.precio}  p/metro`
              : `${this.precio}`;
          this.showPrecio = true;
        } else {
          this.precio = "Solicita el precio";
          this.showPrecio = true;
        }
      } else {
        this.sendSnack(`Hubo un problema al obtener la precio del producto`);
      }
    },
  },

  computed: {},

  watch: {},

  created: function () {
    if (localStorage.token) this.session = true;
    this.showBtn = !this.clientId ? false : true;
    this.getPrecio(this.itemId, this.unitType, this.clientId);
  },

  mounted() {},
};
</script>

<style lang="scss" scoped>
.v-btn:not(.v-btn--round).v-size--default {
  height: 28px;
  padding: 0 4px;
}

.v-btn.v-size--default,
.v-btn.v-size--large {
  font-size: 1.2rem;
}

.btnPrecioSesionOn {
  display: inline-block;
}

.btnPrecioClass {
  display: inline-block;
}

.btnPrecioSesionOff {
  display: inline-block;
}

.precioClass ::v-deep input {
  text-align: center;
}
.precioClass {
  transform: scale(0.8);
  transform-origin: left;
}

.precio-p {
  line-height: 1.8rem;
  text-align: center;
  padding: 0 4px;
  margin: 0 4px;
}

.precio-div {
  border: #ff9800 dotted 1px;
  border-radius: 4px;
  min-height: 2rem;
  padding: 4px 0;
}

.precio-strong {
  font-weight: 500;
  color: #ff9800;
}

.headline {
  font-size: 2rem !important;
  line-height: 2.25rem !important;
}
</style>
